export interface KeyToCount {
  key: string;
  count: number;
}

export interface AdminDashboardTrendPointModel {
  date: string; // yyyy-MM-dd
  transactionalEmailSent: number;
  campaignEmailSent: number;
  whatsAppSent: number;
  smsSent: number;
}

export interface AdminDashboardDateRangeParams {
  days?: number;
  startDate?: string;
  endDate?: string;
  allTime?: boolean;
  // 1 Jan this year to today, one trend point per month
  ytd?: boolean;
}

export interface AdminDashboardStatisticsModel {
  totalAccount: number;
  totalContacts: number;
  totalMonthlySubscriptionFees: number;
  totalStorageUsed: number;
  totalStorageAllocated: number;
  totalTransactionalEmailSent: number;
  totalCampaignEmailSent: number;
  totalWhatsAppSent: number;
  totalSmsSent: number;
  totalActivitySubmitted: number;
  totalActivityProcessed: number;

  accountsByPlan: KeyToCount[];
  accountsByCountry: KeyToCount[];

  hasError: boolean;
  failedTenantIds: string[];
  genericErrors: string[];

  activityTrend: AdminDashboardTrendPointModel[];
  activityTrendGranularity: 'DAILY' | 'WEEKLY' | 'MONTHLY';
  transactionalEmailSentPercentChange: number | null;
  campaignEmailSentPercentChange: number | null;
  whatsAppSentPercentChange: number | null;
  smsSentPercentChange: number | null;

  accountsWithNoPlan: number;
  accountsNearingStorageLimit: number;
  accountsNearingEmailQuota: number;
  accountsNearingSmsCreditLimit: number;
  totalBouncedEmails: number;
  totalFailedWhatsApp: number;
  totalFailedSms: number;
}
